import axios from 'axios';

const resolveApiUrl = () => {
  const envUrl = process.env.REACT_APP_API_URL?.trim();
  if (envUrl) return envUrl.replace(/\/+$/, '');

  // CRA dev server (port 3000) — API runs on a separate backend port locally.
  if (
    process.env.NODE_ENV === 'development' &&
    window.location.hostname === 'localhost' &&
    window.location.port === '3000'
  ) {
    return 'http://localhost:5000/api';
  }

  return `${window.location.origin}/api`;
};

const API_URL = resolveApiUrl();

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  timeout: 15000,
});

// Add token to requests
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Handle auth errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default api;
